import { timeRangeOptions, timeRangeValues } from '@/common/components/TimeRangeSelect/constants'
import routes from '@/Router/routes.constants'

export const performanceInsightsTabValues = {
  global: 'global',
  markets: 'markets',
  products: 'products',
  logistics: 'logistics',
}

export const performanceInsightsTabs = [
  { label: 'Global', value: performanceInsightsTabValues.global, path: routes.performanceInsightsPage.global },
  { label: 'Mercados', value: performanceInsightsTabValues.markets, path: routes.performanceInsightsPage.markets },
  { label: 'Productos', value: performanceInsightsTabValues.products, path: routes.performanceInsightsPage.products },
  { label: 'Logística', value: performanceInsightsTabValues.logistics, path: routes.performanceInsightsPage.logistics },
]

export const performanceInsightsPeriodOptions = timeRangeOptions.filter(
  option => option.value !== timeRangeValues.lastWeek
)

export const defaultPerformanceInsightsPeriod = { timeRange: timeRangeValues.lastMonth }

export const performanceInsightsContentStatuses = {
  loading: 'loading',
  empty: 'empty',
  ready: 'ready',
}
